import * as React from "react";
import Box from "@mui/material/Box";
import { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import { DatePicker, TimePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import EditIcon from "@mui/icons-material/Edit";
import dayjs from "dayjs";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";

import Typography from "@mui/material/Typography";

import { Chip, IconButton, InputAdornment } from "@mui/material";

import { useDispatch, useSelector } from "react-redux";

import MyLocationsSmallCard from "./MyLocationsSmallCard";

import BulkMeetingCreation from "./BulkMeetingCreation";
import { toast } from "react-toastify";
import { setpreviewLogout } from "../../redux/slices/Preview";

import LayoutItemList from "./LayoutItemList.js";
import { setScheduleLogout } from "../../redux/slices/scheduleSectionSlice.js";
import { setSelectedLayoutLogout } from "../../redux/slices/selectedLayoutSlice.js";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";



const style = {
  width: "100vw",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  bgcolor: "background.paper",
  padding: 2,
};

export default function MyScheduleForm() {
  const [open, setOpen] = useState(false);
  const [currentIndices, setCurrentIndices] = useState({});
  const [scheduleName, setScheduleName] = useState("");
  const [selectedPlaylist, setSelectedPlaylist] = useState(null);
  const [currentView, setCurrentView] = useState("Layout");
  const headers = useSelector((state) => state.header);
  const emmsheaders = useSelector((state) => state.emmsheader);
  const curremms = useSelector((state) => state.curremms);
  const selectedOption = curremms.curremms.id;
  const meetingData = useSelector((state) => state?.meeting?.meeting);
  const [nextClicked, setNextClicked] = useState(false);
  const dataToDisplay = useSelector(
    (state) => state?.dataToDisplay.dataToDisplay
  );
  const [searchQuery, setSearchQuery] = useState("");
  const dataMap = new Map(dataToDisplay?.map((data) => [data.id, data]));

  const handleSelectPlaylist = (playlistId) => {
    setSelectedPlaylist(playlistId);
  };

  const [formData, setFormData] = React.useState({
    startDate: dayjs(),
    endDate: dayjs(), 
    startTime: dayjs(), 
    endTime: dayjs().add(1, "hour"), 
    name: "",
    user: "",
  });
  const eventcustomisations = useSelector(
    (state) => state.eventcustomisations.eventcustomisations
  );
  const dispatch = useDispatch();
  const location = useSelector((state) => state.location.location);
  const playlist = useSelector((state) => state?.playlist?.playlist);
  const selectedLayout = useSelector(
    (state) => state?.selectedLayout?.selectedLayout
  );
  const selectedLayoutItems = useSelector(
    (state) => state.selectedLayout.selectedLayoutPlaylistItems
  );

  const api = localStorage.getItem("api");
  const locationId = useSelector((state) => state?.schedule?.locationIds);
  const roomIds = useSelector((state) => state?.schedule?.roomIds);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const [scheduleDateExpanded, setScheduleDateExpanded] = React.useState(false);
  const [locationsExpanded, setLocationsExpanded] = React.useState(false);


  const handleOpen = () => {
    setOpen(true);
    dispatch(setSelectedLayoutLogout());
    setFormData({
      startDate: dayjs(), 
      endDate: dayjs(), 
      startTime: dayjs(), 
      endTime: dayjs().add(1, "hour"),
      name: "",
      user: "",
    });
  };

  const handleClose = () => {
    setOpen(false);
    setFormData({
      startDate: null,
      endDate: null,
      startTime: null,
      endTime: null,
      name: "",
      user: "",
    });
    setNextClicked(false);
    dispatch(setpreviewLogout());
    dispatch(setScheduleLogout());
    dispatch(setSelectedLayoutLogout());
  };

  const handleDateChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };
  const validateForm = () => {
    const { startDate, endDate, name, user, startTime, endTime } = formData;

  
    if (!name || name.trim() === "") {
      toast.error("Name is required.", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      return false;
    }

    if (!user || user.trim() === "") {
      toast.error("Host is required.", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      return false;
    }

    if (!startDate || !endDate) {
      toast.error("Start Date and End Date are required.", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      return false;
    }

    if (dayjs(startDate).isAfter(dayjs(endDate))) {
      toast.error("Start Date must be before End Date.", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      return false;
    }

    if (!startTime || !endTime) {
      toast.error("Start Time and End Time are required.", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      return false;
    }

    if (
      dayjs(`${startDate}T${startTime}`).isAfter(dayjs(`${endDate}T${endTime}`))
    ) {
      toast.error("Start Time must be before End Time.", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      return false;
    }
  
    if (!roomIds || roomIds?.length === 0) {
      toast.error("Please select at least one room.", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      return false;
    }
    if (!selectedLayout) {
      toast.error("Please select the layout", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      return false;
    }

    return true;
  };

  const handleNextClicked = () => {
    if (validateForm()) {
      setNextClicked(true);
    }
  };

  useEffect(() => {
    const existingMeetingObject =
      JSON.parse(localStorage.getItem("meetingObject")) || {};

    const formattedData = {
      ...formData,
      startDate: dayjs(formData.startDate).format("YYYY-MM-DD"),
      endDate: dayjs(formData.endDate).format("YYYY-MM-DD"),
      startTime: formData.startTime,
      endTime: formData.endTime,
    };

    const updatedMeetingObject = {
      ...existingMeetingObject,
      ...formattedData,
    };


    localStorage.setItem("meetingObject", JSON.stringify(updatedMeetingObject));
  }, [formData]);

  const modalClose = () => {
    setOpen(false);
    setNextClicked(false);
    const meetingObj = localStorage.getItem("meetingObject");
    const meetingObject = JSON.parse(meetingObj);
    if (meetingObject?.customProperties?.customisationId) {
      delete meetingObject.customProperties.customisationId;
      localStorage.setItem("meetingObject", JSON.stringify(meetingObject));
    }

    dispatch(setpreviewLogout());
    dispatch(setScheduleLogout());

    localStorage.setItem("meetingObject", JSON.stringify({}));
  };
  const handleScheduleNameChange = (e) => {
    const eventName = e.target.value;
    setFormData((prev) => ({
      ...prev,
      name: eventName,
    }));


  };
  const handleHostNameChange = (e) => {
    const userName = e.target.value;
    setFormData((prev) => ({
      ...prev,
      user: userName,
    }));

 
  };

  return nextClicked ? (
    <>
      <BulkMeetingCreation handleClose={handleClose} />
    </>
  ) : (
    <>
      <div>
        <Button
          style={{ textTransform: "none" }}
          variant="contained"
          color="primary"
          onClick={() => {
            handleOpen()
          }}
        >
          Add Schedule
        </Button>
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
           
            <Box
              sx={{
                padding: 2,
                height: { xs: "8vh", md: "10vh" },
                width: "100%",
                borderBottom: "1px solid #ddd",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              {" "}
              <Typography
                color="primary"
                variant="h5"
                sx={{
                  display: {
                    xs: "none",
                    md: "block"
                  }
                }}
              >
                Elhi Landscape Manager
              </Typography>
              <TextField
                label="Schedule/Event Name"
                variant="standard"
                placeholder="Annual Event 2025"
                sx={{ mb: 2 }}
                onChange={handleScheduleNameChange}
                InputLabelProps={{
                  sx: {
                    maxWidth: {
                      xs: "80%",
                      md: "100%",
                    },
                  },
                }}
                InputProps={{
                  endAdornment: <IconButton>{<EditIcon />}</IconButton>,
                }}
              />
              <TextField
                label="Host Name"
                variant="standard"
                placeholder="John Doe"
                sx={{ mb: 2 }}
                onChange={handleHostNameChange}
                InputLabelProps={{
                  sx: {
                    maxWidth: {
                      xs: "80%",
                      md: "100%",
                    },
                  },
                }}
                InputProps={{
                  endAdornment: <IconButton>{<EditIcon />}</IconButton>,
                }}
              />
            </Box>

            <Box
              sx={{
                height: "50vh",
                flex: 1,
                display: "flex",
                flexDirection: { xs: "column-reverse", md: "row" },
                gap: { xs: 0, md: 2 },
              }}
            >
           
              <Box
                sx={{
                  flex: 5,
                  display: "flex",
                  flexDirection: "column",
                  gap: 2,
                }}
                
              >
                
                {isMobile ? (
                  <Accordion
                    expanded={scheduleDateExpanded}
                    onChange={(_, isExpanded) => setScheduleDateExpanded(isExpanded)}
                    disableGutters
                    elevation={0}
                    sx={{ borderRadius: 2, "&:before": { display: "none" } }}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      sx={{ justifyContent: "center" }}
                    >
                      <Chip
                        label="Schedule Date & Time"
                        sx={{
                          fontSize: ".8rem",
                          padding: "4px 12px",
                          borderRadius: "8px",
                        }}
                      />
                    </AccordionSummary>

                    <AccordionDetails>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <Box sx={{ display: "flex", gap: 1, mb: 1.5 }}>
                          <DatePicker
                            label="Start Date"
                            value={formData.startDate}
                            onChange={(value) => handleDateChange("startDate", value)}
                            minDate={dayjs()}
                            sx={(theme) => ({
                              "& .MuiInputBase-input": {
                                [theme.breakpoints.down("md")]: {
                                  padding: "8.5px 14px",
                                },
                              },
                            })}
                          />
                          <DatePicker
                            label="End Date"
                            value={formData.endDate}
                            onChange={(value) => handleDateChange("endDate", value)}
                            minDate={formData?.startDate || dayjs()}
                            sx={(theme) => ({
                              "& .MuiInputBase-input": {
                                [theme.breakpoints.down("md")]: {
                                  padding: "8.5px 14px",
                                },
                              },
                            })}
                          />
                        </Box>

                        <Box sx={{ display: "flex", gap: 1 }}>
                          <TimePicker
                            label="Start Time"
                            value={formData.startTime}
                            onChange={(value) => handleDateChange("startTime", value)}
                            disabled={formData?.startDate?.isBefore(dayjs(), "day")}
                            sx={(theme) => ({
                              "& .MuiInputBase-input": {
                                [theme.breakpoints.down("md")]: {
                                  padding: "8.5px 14px",
                                },
                              },
                            })}
                          />
                          <TimePicker
                            label="End Time"
                            value={formData.endTime}
                            onChange={(value) => handleDateChange("endTime", value)}
                            disabled={!formData?.startTime}
                            sx={(theme) => ({
                              "& .MuiInputBase-input": {
                                [theme.breakpoints.down("md")]: {
                                  padding: "8.5px 14px",
                                },
                              },
                            })}
                          />
                        </Box>
                      </LocalizationProvider>
                    </AccordionDetails>
                  </Accordion>
                ) : (
                  <Box
                    sx={{
                      padding: 1.5,
                      borderRadius: 2,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
                        <Chip
                          label="Schedule Date & Time"
                          sx={{
                            fontSize: ".8rem",
                            padding: "4px 12px",
                            borderRadius: "8px",
                          }}
                        />
                      </Box>
                      <Box>
                        <Box sx={{ display: "flex", gap: 1, mb: { xs: 1.5, md: 3 } }}>
                          <DatePicker
                            label="Start Date"
                            value={formData.startDate}
                            onChange={(value) => handleDateChange("startDate", value)}
                            minDate={dayjs()}
                            sx={(theme) => ({
                              "& .MuiInputBase-input": {
                                [theme.breakpoints.down("md")]: {
                                  padding: "8.5px 14px",
                                },
                              },
                            })}
                          />
                          <DatePicker
                            label="End Date"
                            value={formData.endDate}
                            onChange={(value) => handleDateChange("endDate", value)}
                            minDate={formData?.startDate || dayjs()}
                            sx={(theme) => ({
                              "& .MuiInputBase-input": {
                                [theme.breakpoints.down("md")]: {
                                  padding: "8.5px 14px",
                                },
                              },
                            })}
                          />
                        </Box>
                        <Box sx={{ display: "flex", gap: 1 }}>
                          <TimePicker
                            label="Start Time"
                            value={formData.startTime}
                            onChange={(value) => handleDateChange("startTime", value)}
                            disabled={formData?.startDate?.isBefore(dayjs(), "day")}
                            sx={(theme) => ({
                              "& .MuiInputBase-input": {
                                [theme.breakpoints.down("md")]: {
                                  padding: "8.5px 14px",
                                },
                              },
                            })}
                          />
                          <TimePicker
                            label="End Time"
                            value={formData.endTime}
                            onChange={(value) => handleDateChange("endTime", value)}
                            disabled={!formData?.startTime}
                            sx={(theme) => ({
                              "& .MuiInputBase-input": {
                                [theme.breakpoints.down("md")]: {
                                  padding: "8.5px 14px",
                                },
                              },
                            })}
                          />
                        </Box>
                      </Box>
                    </LocalizationProvider>
                  </Box>
                )}


                {isMobile ? (
                  <Accordion
                    expanded={locationsExpanded}
                    onChange={(_, isExpanded) => setLocationsExpanded(isExpanded)}
                    disableGutters
                    elevation={0}
                    sx={{ borderRadius: 2, "&:before": { display: "none" } }}
                  >
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <Chip
                        label="Locations & Venues"
                        sx={{
                          fontSize: ".8rem",
                          padding: "4px 12px",
                          borderRadius: "8px",
                        }}
                      />
                    </AccordionSummary>

                    <AccordionDetails>
                      <MyLocationsSmallCard locations={location} />
                    </AccordionDetails>
                  </Accordion>
                ) : (
                  <Box
                    sx={{
                      padding: 2,
                      borderRadius: 2,
                      height: "100%",
                      overflowY: "hidden",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        mb: 1,
                      }}
                    >
                      <Chip
                        label="Locations & Venues"
                        sx={{
                          fontSize: ".8rem",
                          padding: "4px 12px",
                          borderRadius: "8px",
                        }}
                      />
                    </Box>
                    <MyLocationsSmallCard locations={location} />
                  </Box>
                )}
              </Box>

              <Box
                sx={{
                  flex: {xs:11,md:4},
                  padding: 1,
                  overflowY: "auto",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  gap: 2,

                  "&::-webkit-scrollbar": {
                    width: "6px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    backgroundColor: "#888",
                    borderRadius: "10px",
                    border: "2px solid transparent",
                    backgroundClip: "padding-box",
                  },
                  "&::-webkit-scrollbar-thumb:hover": {
                    backgroundColor: "#555",
                  },
                  "&::-webkit-scrollbar-track": {
                    backgroundColor: "transparent",
                  },
                }}
              >
                <Box
                  sx={{
                    flex: 4,
                    padding: 1,
                    overflowY: "auto",
                    display: "flex",
                    flexDirection: "column",
                    width: { xs: "100%", md: "auto" },
                    alignItems: "flex-start",
                    gap: 2,
                    "&::-webkit-scrollbar": {
                      width: "6px",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      backgroundColor: "#888",
                      borderRadius: "10px",
                      border: "2px solid transparent",
                      backgroundClip: "padding-box",
                    },
                    "&::-webkit-scrollbar-thumb:hover": {
                      backgroundColor: "#555",
                    },
                    "&::-webkit-scrollbar-track": {
                      backgroundColor: "transparent",
                    },
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      mb: 1,

                      width: "100%",
                    }}
                  >
                    <Chip
                      label="Select Layout"
                      sx={{
                        fontSize: ".8rem",
                        padding: "4px 12px",
                        borderRadius: "8px",
                      }}
                    />
                    <TextField
                      size="small"
                      variant="standard"
                      placeholder="Search Layouts..."
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                        endAdornment: searchQuery && (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() => setSearchQuery("")}
                              size="small"
                            >
                              <ClearIcon />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      sx={{ mb: 2 }}
                    />
                  </Box>

                  {currentView === "Layout" && (
                    <>
                      <LayoutItemList searchQuery={searchQuery} />
                    </>
                  )}
                </Box>
              </Box>
            </Box>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                gap: "1rem",
                mr: "1em",
              }}
            >
              <Button
                variant="outlined"
                onClick={modalClose}
                color="error"
                style={{ textTransform: "none" }}
              >
                Close
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={handleNextClicked}
                style={{ textTransform: "none" }}
              >
                Next
              </Button>
            </div>
          </Box>
        </Modal>
      </div>
    </>
  );
}
